import { render, staticRenderFns } from "./customerRepurchaseItemTag.vue?vue&type=template&id=a93c3bb4&scoped=true"
import script from "./customerRepurchaseItemTag.vue?vue&type=script&lang=js"
export * from "./customerRepurchaseItemTag.vue?vue&type=script&lang=js"
import style0 from "./customerRepurchaseItemTag.vue?vue&type=style&index=0&id=a93c3bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93c3bb4",
  null
  
)

export default component.exports